import tokenDecoder from 'jwt-decode';
import Vue from 'vue';

const JwtService = {
    getToken() {
        return window.localStorage.getItem(process.env.JWT_TOKEN_KEY);
    },

    saveToken(token) {
        window.localStorage.setItem(process.env.JWT_TOKEN_KEY, token);
    },

    setAuthHeader() {
        const token = window.localStorage.getItem(process.env.JWT_TOKEN_KEY);

        if (!token) {
            return;
        }

        Vue.axios.defaults.headers.common.Authorization = `Bearer ${token}`;

        // Dirty hack for websockets
        window.Echo.connector.pusher.config.auth.headers.Authorization = `Bearer ${token}`;
    },

    getUserId() {
        const token = window.localStorage.getItem(process.env.JWT_TOKEN_KEY);

        const decodedToken = tokenDecoder(token);

        return decodedToken.sub;
    },

    clearToken() {
        window.localStorage.removeItem(process.env.JWT_TOKEN_KEY);

        delete Vue.axios.defaults.headers.common.Authorization;
    },
};

export default JwtService;



// WEBPACK FOOTER //
// ./src/services/JwtService.js